import {CommonModule} from '@angular/common';
import {Component, computed} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {AuthService} from '@core/auth/auth.service';
import {TooltipModule} from 'primeng/tooltip';
import {SidebarService} from '../sidebar.service';

interface NavItem {
  icon: string;
  label: string;
  route: string;
  roles: ('SUPER_ADMIN' | 'ADMIN')[];
}

const NAV_ITEMS: NavItem[] = [
  {icon: 'pi-chart-bar', label: 'Dashboard', route: '/dashboard', roles: ['SUPER_ADMIN', 'ADMIN']},
  {icon: 'pi-building', label: 'Workspaces', route: '/workspaces', roles: ['SUPER_ADMIN', 'ADMIN']},
  {
    icon: 'pi-shield',
    label: 'Super Admins',
    route: '/super-admins',
    roles: ['SUPER_ADMIN'],
  },
  {icon: 'pi-user', label: 'Profile', route: '/profile', roles: ['SUPER_ADMIN', 'ADMIN']},
];

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, TooltipModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  readonly navItems = computed(() => {
    const role = this.auth.admin()?.role;
    return NAV_ITEMS.filter(item => (role ? item.roles.includes(role) : false));
  });

  constructor(
    public sidebarService: SidebarService,
    public auth: AuthService
  ) {}

  getUserInitial(): string {
    const name = this.auth.admin()?.name;
    if (!name) {
      return '';
    }

    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase();
  }

  onLogOut(): void {
    this.auth.logout();
  }
}
